export const BASE_URL = process.env.VUE_APP_API_URL;
export const API_KEY = process.env.VUE_APP_API_KEY;
export const WEB_BASE_URL = process.env.VUE_APP_BASE_URL;
